module.exports = __webpack_public_path__ + "img/15.24ac8f32.jpg";